// src/components/MomPanel.jsx
import React from "react";

const MomPanel = ({
  transcriptDraft,
  setTranscriptDraft,
  mom,
  momLoading,
  momError,
  generateMom,
  isAsrAvailable,
  isAsrOn,
  setIsAsrOn
}) => {
  return (
    <div className="room-momContainer">
      <div className="room-momHeaderRow">
        <div>
          <div className="room-momTag">AI MEETING NOTES</div>
          <div style={{ fontSize: 14, color: "#e5e7eb", marginTop: 2 }}>
            Auto-capture speech into transcript and generate MoM in one click.
          </div>
          {isAsrAvailable ? (
            <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>
              Web Speech API detected – works best on Chrome over HTTPS.
            </div>
          ) : (
            <div style={{ fontSize: 11, color: "#f97373", marginTop: 4 }}>
              Browser does not support Web Speech API – auto-capture disabled.
            </div>
          )}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            gap: 6,
          }}
        >
          {isAsrAvailable && (
            <button
              type="button"
              onClick={() => setIsAsrOn((v) => !v)}
              style={{
                padding: "6px 12px",
                borderRadius: 999,
                border: "1px solid rgba(56,189,248,0.8)",
                background: isAsrOn
                  ? "linear-gradient(135deg, #22c55e, #0ea5e9)"
                  : "rgba(15,23,42,0.9)",
                color: "#f9fafb",
                fontSize: 12,
                cursor: "pointer",
                boxShadow: isAsrOn
                  ? "0 8px 20px rgba(34,197,94,0.35)"
                  : "0 4px 12px rgba(15,23,42,0.8)",
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                minWidth: 150,
                justifyContent: "center",
              }}
            >
              {isAsrOn ? "🛑 Stop Auto-Capture" : "🎙️ Start Auto-Capture"}
            </button>
          )}

          <button
            onClick={() => generateMom(transcriptDraft)}
            disabled={momLoading || !transcriptDraft.trim()}
            style={{
              padding: "7px 14px",
              borderRadius: 999,
              border: "1px solid rgba(45,212,191,0.8)",
              fontSize: 13,
              fontWeight: 500,
              cursor: momLoading ? "default" : "pointer",
              background: momLoading
                ? "rgba(15,23,42,0.7)"
                : "linear-gradient(135deg, #0ea5e9, #22c55e)",
              color: "#f9fafb",
              boxShadow: momLoading
                ? "0 4px 14px rgba(15,23,42,0.7)"
                : "0 8px 22px rgba(34,197,94,0.35)",
              opacity: momLoading ? 0.7 : 1,
              whiteSpace: "nowrap",
            }}
          >
            {momLoading ? "Generating…" : "Generate MoM"}
          </button>
        </div>
      </div>

      <textarea
        value={transcriptDraft}
        onChange={(e) => setTranscriptDraft(e.target.value)}
        placeholder="Type / paste the key points or transcript from the call..."
        rows={4}
        className="room-momTextarea"
      />

      {momError && <div className="room-momError">{momError}</div>}

      {mom && (
        <div className="room-momBody">
          {mom}
        </div>
      )}
    </div>
  );
};

export default MomPanel;
